import { InjectionToken } from '@angular/core';

export const DEVSTROUPE_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('DEVSTROUPE_MOCK_API_DEFAULT_DELAY');
